import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../common/breadcrumb";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { adminInstance } from "../../config/axios";
import { useLocation } from "react-router-dom";
import Loader from "../loader/loader";
import AddGiftCardForm from "./addCardForm";
const AddGiftCard = () => {
  const initialObj = {
    price: "",
    isActive: true,
  };

  const [payload, setPayload] = useState(initialObj);
  const [loading, setLoading] = useState(false);
  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();
  let categoryId = query.get("id");

  const getSingleCategoryData = async (id) => {
    try {
      setLoading(true);
      const response = await adminInstance().get(`api/admin/getGiftCard/${id}`);
      const { code, giftCard } = response.data;
      if (code === 200) {
        setLoading(false);
        setPayload((payload) => ({
          ...payload,
          _id: giftCard._id,
          price: giftCard.amount,
          isActive: giftCard.isActive,
        }));
      }
    } catch (error) {
      console.log("----------->aaa>>", error);
    }
  };
  useEffect(() => {
    if (categoryId) {
      getSingleCategoryData(categoryId);
    }
  }, [categoryId]);

  return (
    <Fragment>
      <Breadcrumb title="Category" parent="Category" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader>
                <h5>Add Gift-Card </h5>
              </CardHeader>
              <CardBody>
                {categoryId ? (
                  !loading ? (
                    payload?._id && (
                      <AddGiftCardForm
                        payload={payload}
                        setPayload={setPayload}
                      />
                    )
                  ) : (
                    <Loader />
                  )
                ) : (
                  <AddGiftCardForm payload={payload} setPayload={setPayload} />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default AddGiftCard;
